import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { NavLink, Link } from "react-router-dom";
import "@css/MobileTabBar.css";

import { useUser } from "@context/contexts";
import { checkRole } from "@utils/index";

const tabs = [
    { label: "Профиль", to: "/profile/", icon: "king" },
    { label: "Обучение", to: "/program/", icon: "pawn" },
    { label: "Челленджи", to: "/challenges/", icon: "knight" },
    { label: "Турниры", to: "/tournaments/", icon: "rook" },
];

const extraRows = [
    { label: "Корзина", to: "/cart/" },
    { label: "Звания", to: "/ranks/" },
    { label: "Координаты", to: "/coordinate/" },
    { label: "Транзакции", to: "/transactions/" },
    { label: "Уведомления", to: "/profile/notifications/" },
];

// Fixed bottom tab bar at 768px or below, for students and admins. `links` is
// Header's feature-flag-filtered list (userLinks or adminLinks, per view);
// links that have a tab are skipped, the rest go into the "Ещё" sheet.
const MobileTabBar = ({ links, onSupportClick }) => {
    const { userData, isAdminView, setIsAdminView, logout } = useUser();
    const dialogRef = useRef(null);
    const tabPaths = tabs.map(t => t.to);

    useEffect(() => {
        document.body.classList.add("has-tab-bar");
        return () => document.body.classList.remove("has-tab-bar");
    }, []);

    const close = () => dialogRef.current?.close();
    const open = () => dialogRef.current?.showModal();

    const sheetLinks = links.filter(item => !item.to || !tabPaths.includes(item.to));
    const plain = sheetLinks.filter(item => item.to);
    const groups = sheetLinks.filter(item => item.dropdown);
    // Student view lists personal pages; admin view has them inside its groups.
    const rows = isAdminView ? plain : [...extraRows, ...plain];
    const support = sheetLinks.find(item => item.isSentryFeedback);

    return (
        <>
            <nav className="mobile-tab-bar" aria-label="Основная навигация">
                {tabs.map(tab => (
                    <NavLink key={tab.to} to={tab.to} className="mobile-tab">
                        {({ isActive }) => (
                            <>
                                <img src={`/images/${tab.icon}-${isActive ? "black" : "white"}.png`} alt="" width="24" height="24" />
                                <span>{tab.label}</span>
                            </>
                        )}
                    </NavLink>
                ))}
                <button type="button" className="mobile-tab" onClick={open}>
                    <span className="mobile-tab-glyph" aria-hidden="true">⋯</span>
                    <span>Ещё</span>
                </button>
            </nav>
            <dialog
                ref={dialogRef}
                className="mobile-sheet"
                aria-label="Ещё"
                onClick={e => e.target === dialogRef.current && close()}
            >
                <ul className="mobile-sheet-list" onClick={close}>
                    {rows.map(row => (
                        <li key={row.to}><Link to={row.to} className="mobile-sheet-row">{row.label.trim()}</Link></li>
                    ))}
                    {groups.map(group => (
                        <li key={group.label}>
                            <p className="mobile-sheet-heading">{group.label}</p>
                            <ul>
                                {group.dropdown.filter(sub => !sub.disabled && sub.to && !tabPaths.includes(sub.to)).map(sub => (
                                    <li key={sub.to}><Link to={sub.to} className="mobile-sheet-row">{sub.label.trim()}</Link></li>
                                ))}
                            </ul>
                        </li>
                    ))}
                    {support ? (
                        <li className="mobile-sheet-divider">
                            <button type="button" className="mobile-sheet-row" onClick={onSupportClick}>{support.label}</button>
                        </li>
                    ) : null}
                    {checkRole(userData, "moderator") && (
                        <li>
                            <button type="button" className="mobile-sheet-row" onClick={() => setIsAdminView(!isAdminView)}>
                                {isAdminView ? "Режим ученика" : "Режим администратора"}
                            </button>
                        </li>
                    )}
                    <li><button type="button" className="mobile-sheet-row" onClick={logout}>Выйти</button></li>
                </ul>
            </dialog>
        </>
    );
};

MobileTabBar.propTypes = {
    links: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSupportClick: PropTypes.func.isRequired,
};

export default MobileTabBar;
